import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import { ApolloClient, InMemoryCache } from "@apollo/client";
import MiniBasket from './components/Booking/MiniBasket';
import LoadingAnim from './UIComponents/LoadingAnim';
import UIStore from './hooks/ui-store';
import TicketsStore from './hooks/tickets-store';
import CalendarStore from './hooks/calendar-store';
import RedemptionStore from './hooks/redemption-store';

UIStore();
TicketsStore();
CalendarStore();
RedemptionStore();

const Redemption = lazy(() => import('./containers/Redemption'));
const Tickets = lazy(() => import('./containers/Tickets'));
// const Timer = lazy(() => import('./components/Timer'));

const client = new ApolloClient({
  uri: '/graphql',
  cache: new InMemoryCache()
});

const App = props => {
    const _props = props;
    return (
        <Router>
          <Suspense fallback={<LoadingAnim/>}>
            <Route path="/buy-tickets"
                   render={(props) => <Suspense fallback={<LoadingAnim/>}><Tickets {...props} pageID={_props.pageID} ticketTypes={_props.ticketPosts} hash={_props.hash} heroBg={_props.heroBg} faqs={_props.faqs} /></Suspense>} />
            <Route path="/gift-tickets/redeem" render={(props) => <Suspense fallback={<LoadingAnim/>}><Redemption {...props} pageID={_props.pageID}/></Suspense>} heroBg={_props.heroBg} faqs={_props.faqs} />
          </Suspense>
        </Router>
    );
}

const hash = window.location.hash.replace(/^#\/?|\/$/g, '').split('/');
let section = hash[0] === '' ? null : hash[0];

// Split location into `/` separated parts, then render `Application` with it
function handleNewHash() {
    // Allow partial mention of the slug in the url hash
    var types = JSON.parse(el.getAttribute('data-ticket-posts'));
    if (section && !Object.keys(types).includes(section)) {
        for (const [key, value] of Object.entries(types)) {
            if (key.includes(section)) {
                section = key;
            }
        }
    }
    const ticketTypes = el.getAttribute('data-ticket-posts');
    const hero = el.getAttribute('data-hero-bg');
    const faqContent = JSON.parse(el.getAttribute('data-faqs'));
    const tT = JSON.parse(ticketTypes);

    for (let [key, value] of Object.entries(tT)) {
        tT[key] = JSON.parse(value)
    }
    const application = el.getAttribute('data-ticket-posts') ?
      <React.StrictMode><ApolloProvider client={client}><App pageID={el.getAttribute('data-page-id')} ticketPosts={tT} hash={section} heroBg={hero} faqs={faqContent}/></ApolloProvider></React.StrictMode>
      :
      <React.StrictMode>
        <App/>
      </React.StrictMode>;
      ReactDOM.render(application, el);

    const cartEl = document.getElementById('cart');
    if (cartEl) {
      ReactDOM.render(
        <React.StrictMode>
          <MiniBasket hash={section} />
        </React.StrictMode>,
        cartEl
      );
    }
}
const redemptionEl = document.getElementById('redemption');
if (redemptionEl) {
    const hero = redemptionEl.getAttribute('data-hero-bg');
    const faqContent = JSON.parse(redemptionEl.getAttribute('data-faqs'));
    const redemptionApp = <React.StrictMode><Suspense fallback={<LoadingAnim/>}><Redemption pageID={redemptionEl.getAttribute('data-page-id')} heroBg={hero} faqs={faqContent} /></Suspense></React.StrictMode>;
    ReactDOM.render(redemptionApp, redemptionEl);
}

const el = document.getElementById('booking');
if (el) {
    handleNewHash()
    window.addEventListener('hashchange', handleNewHash, false);
}

// const timerEl = document.getElementById('timer');
// if (timerEl) {
//     const timerApp = <React.StrictMode><Suspense fallback={<LoadingAnim/>}><Timer /></Suspense></React.StrictMode>;
//     ReactDOM.render(timerApp, timerEl);
// }

export default App;
